import { VOICE_EXTRA_NUMBER_BASE_BRL, VOICE_EXTRA_NUMBER_PRO_BRL } from '@/config/voicePricing'

const STARTER_MONTHLY_PRICE_ID = 'price_1TF7PAE9Nnliuzv1vtRUKQYG'
const STARTER_ANNUAL_PRICE_ID = 'price_1TF7PAE9Nnliuzv1kzb9u79r'
const PRO_MONTHLY_PRICE_ID = 'price_1TF7QOE9Nnliuzv1Xn4FnYkL'
const PRO_ANNUAL_PRICE_ID = 'price_1TF7QOE9Nnliuzv1aJ03Vs9l'

export const voicePlans = [
  {
    id: 'starter',
    name: 'Starter',
    description: 'Ideal para operação pequena',
    monthlyPrice: 149,
    monthlyPriceId: import.meta.env.VITE_VOICE_PLAN_STARTER_PRICE_ID || STARTER_MONTHLY_PRICE_ID,
    annualPriceId: import.meta.env.VITE_VOICE_PLAN_STARTER_ANNUAL_PRICE_ID || STARTER_ANNUAL_PRICE_ID,
    includedNumbers: 1,
    extraNumberPrice: VOICE_EXTRA_NUMBER_BASE_BRL,
  },
  {
    id: 'pro',
    name: 'Pro',
    description: 'Para equipes com maior volume',
    monthlyPrice: 250,
    monthlyPriceId: import.meta.env.VITE_VOICE_PLAN_PRO_PRICE_ID || PRO_MONTHLY_PRICE_ID,
    annualPriceId: import.meta.env.VITE_VOICE_PLAN_PRO_ANNUAL_PRICE_ID || PRO_ANNUAL_PRICE_ID,
    includedNumbers: 3,
    extraNumberPrice: VOICE_EXTRA_NUMBER_PRO_BRL,
    badge: 'Recomendado',
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    description: 'Escala avançada e suporte dedicado',
    monthlyPrice: null,
    monthlyPriceId: import.meta.env.VITE_VOICE_PLAN_ENTERPRISE_PRICE_ID || '',
    annualPriceId: import.meta.env.VITE_VOICE_PLAN_ENTERPRISE_ANNUAL_PRICE_ID || '',
    includedNumbers: null,
    extraNumberPrice: null,
  },
]

export function getVoicePlanById(planId) {
  return voicePlans.find((p) => p.id === planId) || null
}
